import { constants } from '@/constants'
import { LinksActionType } from '@/store/modules/links/interfaces'
import { IPortalHardCodeLink } from '@/store/modules/links/interfaces/IPortalHardCodeLink'
import { RolePermissionDetails } from '@/store/modules/users/interfaces/IUser'
import { getValueByLabel } from '@/utils/permissions'
import { defineComponent } from 'vue'
import { mapState } from 'vuex'
import { IPermissionsConfig } from '@/store/modules/main/intefaces/IConfig'

export default defineComponent({
  data: () => ({
    clientWidth: 0
  }),
  computed: {
    ...mapState('main', ['permissions']),
    userMenuPermission (): IPermissionsConfig {
      return this.permissions || []
    },
    user () {
      return this.$store.state.auth.user
    },
    allPermission () {
      return this.user.allAvailablePermission
    },
    customerType (): any {
      if (this.user && this.user?.permissionSchema?.length > 0) {
        return this.user?.permissionSchema[0]?.rpDetails?.find((item: RolePermissionDetails) => item.customerType)
      }
      return []
    },
    portalHardCodeLink (): IPortalHardCodeLink[] {
      return this.$store.state.links.portalHardCodeLink?.results ?? []
    },
    menu () {
      return [
        {
          name: 'xx',
          isActive: true,
          children: [
            ...this.checkPermission('Home Page', {
              label: 'Hlavní stránka',
              href: '/',
              name: 'home',
              isActive: false,
              icon: 'home-alt'
            }),
            ...this.checkPermission('My Profile', {
              label: 'Můj profil',
              href: '/profile/details',
              name: 'profile',
              isActive: false,
              icon: 'user'
            }),
            ...this.checkPermission('Catalogue', {
              label: 'Katalog',
              name: 'catalog',
              isActive: false,
              icon: 'beer',
              children: [
                {
                  label: 'Produkty',
                  href: '/catalog/products',
                  name: 'products',
                  isActive: false
                },
                {
                  label: 'Moje oblíbené',
                  href: '/catalog/favorites',
                  name: 'favorites',
                  isActive: false
                },
                {
                  label: 'Order Bulk Upload',
                  href: '/catalog/bulk-upload',
                  name: 'bulkUpload',
                  isActive: false
                }
              ]
            }),

            ...this.checkPermission(
              'My Orders',
              {
                label: 'Pedidos',
                name: 'orders',
                isActive: false,
                icon: 'shopping-bag',
                children: [
                  {
                    label: 'Historie objednávek',
                    href: '/orders/history',
                    name: 'history',
                    isActive: false
                  },
                  {
                    label: 'Plan de livrare',
                    href: '/orders/delivery-plan',
                    name: 'deliveryPlan',
                    isActive: false
                  },
                  {
                    label: 'Pedidos guardados no enviados',
                    href: '/orders/saved',
                    name: 'savedOrders',
                    isActive: false
                  }
                ]
              },
              this.isDistributorLUser
            ),
            ...this.checkPermission(
              'Empties Management',
              {
                label: 'Container Manager',
                href: '/container-manager',
                name: 'containerManager',
                isActive: false,
                icon: 'university'
              },
              this.isDistributorLUser
            ),
            ...this.checkPermission('My Documents', {
              label: 'Moje dokumenty',
              href: '/my-documents',
              name: 'myDocuments',
              isActive: false,
              icon: 'newspaper'
            }),

            // change once we get the updated
            ...this.checkPermission('Reporting', {
              label: 'Přehled odběrů',
              name: 'reporting',
              isActive: false,
              icon: 'newspaper',
              children: [
                {
                  label: 'Dashboard Principal',
                  href: '/reporting/MainDashboard',
                  name: 'mainDashboard',
                  isActive: false
                },
                {
                  label: 'Dashboard vânzări',
                  href: '/reporting/MainSalesDashboard',
                  name: 'mainSalesDashboard',
                  isActive: false
                },
                {
                  label: 'Plan livrare',
                  href: '/reporting/DeliveryPlan',
                  name: 'deliveryPlanReport',
                  isActive: false
                },
                {
                  label: 'Vânzări zilnice',
                  href: '/reporting/DailySalesReport',
                  name: 'dailySales',
                  isActive: false
                },
                {
                  label: 'Acuratețe sellout',
                  href: '/reporting/SellOutAccuracy',
                  name: 'selloutAccuracy',
                  isActive: false
                },
                {
                  label: 'Stocuri',
                  href: '/reporting/Stock',
                  name: 'Stocks',
                  isActive: false
                },
                {
                  label: 'Stocuri produse',
                  href: '/reporting/DailyStockProducts',
                  name: 'dailyStocks',
                  isActive: false
                },
                {
                  label: 'Stocuri ambalaje',
                  href: '/reporting/DailyStockOfEmpties',
                  name: 'dailyStocksOfEmpties',
                  isActive: false
                },
                {
                  label: 'Acuratețe stocuri',
                  href: '/reporting/StockAccuracy',
                  name: 'stockAccuracy',
                  isActive: false
                },
                {
                  label: 'Univers Facturat',
                  href: '/reporting/InvoicedUniverse',
                  name: 'invoicedUniverse',
                  isActive: false
                },
                {
                  label: 'Structura univers',
                  href: '/reporting/UniverseStructure',
                  name: 'structureOfTheUniverse',
                  isActive: false
                },
                {
                  label: 'Portofoliu',
                  href: '/reporting/PortfolioAnalysisInvoicedProducts',
                  name: 'portfolio',
                  isActive: false
                },
                {
                  label: 'Volume',
                  href: '/reporting/VolumeSOFreeBeer',
                  name: 'volumes',
                  isActive: false
                },
                {
                  label: 'Mapare',
                  href: '/reporting/MasterDataMapping',
                  name: 'mapping',
                  isActive: false
                },
                {
                  label: 'Staus raportare',
                  href: '/reporting/ReportingStatus',
                  name: 'reportingStatus',
                  isActive: false
                },
                {
                  label: 'Retur ambalaje',
                  href: '/reporting/ReturnEmpties',
                  name: 'emptiesReturn',
                  isActive: false
                }
              ]
            }),
            ...this.checkPermission('Contracts', {
              label: 'Přehled smluv',
              href: '/contracts',
              name: 'contracts',
              isActive: false,
              icon: 'file-contract'
            }),
            ...this.checkPermission('Support', {
              label: 'Podpora',
              href: '/support/faq',
              name: 'support',
              isActive: false,
              icon: 'question-circle',
              children:
                this.isOutletUser || this.isDistributorBasicUser
                  ? [
                      {
                        label: 'Otázky a odpovědi',
                        href: '/support/faq',
                        name: 'faq',
                        isActive: false
                      },
                      {
                        label: 'O portálu',
                        href: '/support/knowledge-base',
                        name: 'knowledgeBase',
                        isActive: false
                      }
                    ]
                  : [
                      {
                        label: 'Otázky a odpovědi',
                        href: '/support/faq',
                        name: 'faq',
                        isActive: false
                      },
                      {
                        label: 'O portálu',
                        href: '/support/knowledge-base',
                        name: 'knowledgeBase',
                        isActive: false
                      },
                      {
                        label: 'Kontaktujte nás',
                        href: '/support/tickets',
                        name: 'supportTickets',
                        isActive: false
                      }
                    ]
            }),
            ...this.checkPermission('Marketing Materials', {
              label: 'Materiály pro Vás',
              href: '/marketing-materials',
              name: 'marketingMaterials',
              isActive: false,
              icon: 'newspaper'
            }),
            ...this.checkPermission('Training & Learning', {
              label: 'Formazione',
              name: 'trainingLearning',
              href: '/training',
              icon: 'book-open'
            }),
            ...this.checkPermission('News & Events', {
              label: 'Novinky a články',
              href: '/news',
              name: 'newsEvents',
              isActive: false,
              icon: 'newspaper'
            }),
            ...this.checkPermission('About Ursus', {
              label: 'About Ursus',
              href: this.getLinkByName('aboutUrsusMenu').url,
              name: 'aboutUrsusMenu',
              isActive: false,
              icon: 'university'
            }),
            ...this.checkPermission(
              'Menu Creator',
              {
                label: 'Prazdroj menu',
                href: this.getLinkByName('pubMenu').url,
                name: 'pubMenu',
                isActive: false,
                icon: 'book-open'
              },
              this.isOutletUser
            ),
            ...this.checkPermission('Academy', {
              label: 'Prazdroj menu',
              href: this.getLinkByName('eLearning').url,
              name: 'eLearning',
              isActive: false,
              icon: 'book-open'
            })
          ]
        },
        ...this.checkPermission('Catalogue', {
          label: 'Vytvořit objednávku',
          href: '/catalog/products',
          name: 'createAnOrder',
          isActive: true,
          icon: 'shopping-bag'
        }),
        ...this.checkPermission('Catalogue', {
          label: 'MI CARRITO',
          name: 'cart',
          ...(this.clientWidth >= 1000
            ? {
                href: '',
                precart: true
              }
            : {
                href: '/cart'
              }),
          icon: 'shopping-cart'
        }),
        ...this.checkPermission('Catalogue', {
          label: 'Moje oblíbené',
          name: 'favoritesMenu',
          href: '/catalog/favorites',
          icon: 'heart'
        }),
        ...this.checkPermission(
          'Home Page',
          {
            label: 'OLD PORTAL',
            name: 'oldPortal',
            href: this.getLinkByName('oldPortal').url
          },
          this.isDistributorLUser
        )
      ]
    },
    isDistributorLUser () {
      return this.user?.permissionSchema?.some((company) =>
        company.rpDetails?.some((rp) => rp.customerType === 'Distributor')
      )
    },
    isDistributorBasicUser () {
      return this.user?.permissionSchema?.some((company) =>
        company.rpDetails?.some((rp) => rp.rolename === 'Distributor Basic')
      )
    },
    isOutletUser () {
      return this.user?.permissionSchema?.some((company) =>
        company.rpDetails?.some((rp) => rp.customerType === 'Outlets')
      )
    }
  },
  methods: {
    checkPermission (permission: string, value: Record<string, any>, additionalPremmision = true) {
      if (this.customerType) {
        localStorage.setItem('customertype', this.customerType?.customerType)
      }
      const isAllowedWithoutLogin = constants.menuWithoutLogin?.includes(value.name)
      const hasPermission = this.allPermission?.includes(permission) && additionalPremmision
      const menuAccess = getValueByLabel(this.userMenuPermission, permission)
      if ((isAllowedWithoutLogin || hasPermission) && menuAccess) {
        return [value]
      } else {
        return []
      }
    },
    getLinkByName (name: string) {
      const linkObj = this.portalHardCodeLink.find((link) => link.name === name)
      return linkObj ? { url: linkObj.url, label: linkObj.label } : { url: '', label: '' }
    },
    onResizePortal ({ height }: { height: number }) {
      this.clientWidth = document.querySelector('body')?.clientWidth || height
    },

    fetchPortalHardCodeLink () {
      this.$store.dispatch(LinksActionType.FETCH_PORTAL_HARD_CODE_LINK)
    }
  }
})
